import React from 'react'
import TableWrapper from 'components/TableWrapper'
import Table from 'components/Form/Table'
import Button from 'components/Form/Button'
import FormCore from 'components/Form/Core'
import { ListSkeleton } from 'components/Skeleton'
import { ButtonContainer } from 'ui/styled'
import { State, StateTitle, StateText } from '../UserApprovals/styled'
import useManagement from './management-controller'

const areaName = area => area === 'universe' ? 'Universe' : area === 'lite' ? 'Universe Lite' : 'Accelerator'

export default function ManagedUsers({ areas, canInvite, t, onChanged }) {
  const state = useManagement(areas, t, onChanged)
  return (
    <section aria-label={t('identity_management_title')}>
      <TableWrapper title={t('identity_management_title')} searchValue={state.search}
        onSearchChange={event => state.setSearch(event.target.value)} searchPlaceholder={t('identity_management_search')}
        options={areas.map(area => ({ type: area, title: areaName(area) }))} activeOptions={state.area} setActiveOptions={state.changeArea}>
        {state.loading ? <ListSkeleton rows={4} /> : state.error ? (
          <State><StateText>{t('identity_access_unavailable')}</StateText><Button onClick={state.load}>{t('user_approvals_refresh')}</Button></State>
        ) : (
          <Table analytical minWidth={750} rows={state.data?.rows || []} page={state.page} rowsPerPage={20}
            total={state.data?.pagination?.total || 0} onPageChange={state.setPage} pagination={(state.data?.pagination?.total || 0) > 20} columns={[
              { title: t('first_name'), renderCell: ({ row }) => `${row.firstName || ''} ${row.lastName || ''}`.trim() || '—' },
              { title: 'E-mail', ref: 'email' },
              { title: t('company_name'), renderCell: ({ row }) => row.organization?.companyName || '—' },
              { title: t('user_approvals_status'), renderCell: ({ row }) => t(row.access.enabled ? `identity_status_${row.access.status}` : 'identity_status_legacy') },
              { title: t('identity_management_role'), renderCell: ({ row }) => <span title={(row.access.permissions || []).join(', ')}>{row.access.role}</span> },
              { title: t('identity_management_profile'), renderCell: ({ row }) => row.access.profileId || '—' },
              { title: t('identity_management_migration'), renderCell: ({ row }) => (row.migrationReasons || []).map(reason => t(`identity_migration_${reason}`)).join('; ') || '—' },
              { title: t('user_approvals_actions'), renderCell: ({ row }) => canInvite && row.access.status === 'none' && row.access.area !== 'universe' ? (
                <Button outline onClick={() => state.setDecision({ row, status: 'invitation' })}>{t('identity_management_invite')}</Button>
              ) : row.access.enabled && !['none', 'rejected', 'revoked'].includes(row.access.status) ? (
                <ButtonContainer>
                  {row.access.status !== 'suspended' ? <Button outline onClick={() => state.setDecision({ row, status: 'suspended' })}>{t('identity_management_suspend')}</Button> : null}
                  {row.access.status === 'suspended' ? <Button outline onClick={() => state.setDecision({ row, status: 'restore' })}>{t('identity_management_restore')}</Button> : null}
                  <Button outline onClick={() => state.setDecision({ row, status: 'revoked' })}>{t('identity_management_revoke')}</Button>
                </ButtonContainer>
              ) : null },
            ]} />
        )}
      </TableWrapper>
      <StateText>{t(state.area === 'universe' ? 'identity_management_approval_help' : 'identity_management_invite_help')}</StateText>
      {state.area === 'universe' ? <Button outline onClick={state.reviewRequests}>{t('identity_management_review')}</Button> : null}
      {state.invitation ? <State role="status">
        <StateTitle>{t('identity_management_invite_ready')}</StateTitle>
        <StateText>{state.invitation.email} · {t('identity_management_invite_bound')}</StateText>
        <a href={state.invitation.link}>{t('identity_management_open_invite')}</a>
      </State> : null}
      {state.decision ? <State role="alert" aria-live="polite">
        <StateTitle>{t(state.decision.status === 'invitation' ? 'identity_management_invite' : state.decision.status === 'suspended' ? 'identity_management_suspend' : state.decision.status === 'restore' ? 'identity_management_restore' : 'identity_management_revoke')} — {areaName(state.decision.row.access.area)}</StateTitle>
        <StateText>{state.decision.row.email} · {t('identity_management_confirm')}</StateText>
        {state.decision.status === 'invitation' ? <>
          <StateText>{t('identity_management_invite_terms')}</StateText>
          <FormCore ref={state.invitationFormRef} formItems={[{ ref: 'companyName', placeholder: t('company_name'), required: true }]}
            register={state.decision.row.organization} disabled={state.saving || Boolean(state.decision.row.organization?.companyName)} />
        </> : null}
        <ButtonContainer>
          <Button disabled={state.saving} onClick={() => state.setDecision(null)}>{t('cancel')}</Button>
          <Button disabled={state.saving} loading={state.saving} onClick={state.confirm}>{t('identity_management_confirm_action')}</Button>
        </ButtonContainer>
      </State> : null}
    </section>
  )
}
